module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [(!this.$store.getters.modules.includes('1.25')) ? _c('span', {}, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "img-responsive center-block logo",
    attrs: {
      "src": _vm.$store.state.organisationLogo,
      "alt": "Logo"
    }
  })])]) : _vm._e(), _vm._v(" "), (this.$store.getters.modules.includes('1.25')) ? _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    staticStyle: {
      "font-weight": "bold",
      "color": "#1818c3cc"
    },
    attrs: {
      "for": "fromDate"
    }
  }, [_vm._v("Daily Summary: ")]), _vm._v(" "), (!_vm.englishDateEnabled) ? _c('date-picker', {
    attrs: {
      "valueType": "format"
    },
    model: {
      value: (_vm.fromDate),
      callback: function($$v) {
        _vm.fromDate = $$v
      },
      expression: "fromDate"
    }
  }) : _c('InputMask', {
    staticClass: "nepali-calendar",
    attrs: {
      "mask": "9999-99-99",
      "type": "text",
      "id": "fromDate"
    },
    model: {
      value: (_vm.fromDate),
      callback: function($$v) {
        _vm.fromDate = $$v
      },
      expression: "fromDate"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.organisationid != 7 && this.$store.getters.modules.includes('1.25')) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-12"
  }, [_c('process-info-box', {
    staticClass: "purchase",
    attrs: {
      "color-class": "bg-white",
      "icon-classes": ['fa', 'fa fa-cart-arrow-down'],
      "text": "Purchase",
      "number": _vm.totalPurchase,
      "selectedGradient": ['#3F5EBF']
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix visible-sm-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-12"
  }, [_c('process-info-box', {
    attrs: {
      "color-class": "bg-white",
      "icon-classes": ['fa', 'fa fa-shopping-bag'],
      "text": "Sales",
      "number": _vm.totalSales,
      "selectedGradient": ['#42b3f4']
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-12"
  }, [_c('process-info-box', {
    staticClass: "purchase",
    attrs: {
      "color-class": "bg-white",
      "icon-classes": ['pi', 'pi pi-money-bill'],
      "text": "Cash Out",
      "number": _vm.totalCashOut,
      "selectedGradient": ['red']
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-12"
  }, [_c('process-info-box', {
    staticClass: "cashIn",
    attrs: {
      "color-class": "bg-white",
      "icon-classes": ['pi', 'pi pi-money-bill'],
      "text": "Cash In",
      "number": _vm.totalCashIn,
      "selectedGradient": ['green']
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (this.$store.getters.modules.includes('1.25')) ? _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    staticStyle: {
      "font-weight": "bold",
      "color": "#1818c3cc"
    },
    attrs: {
      "for": "fromDate"
    }
  }, [_vm._v("As of date: ")]), _vm._v(" "), (!_vm.englishDateEnabled) ? _c('date-picker', {
    attrs: {
      "valueType": "format"
    },
    model: {
      value: (_vm.toDate),
      callback: function($$v) {
        _vm.toDate = $$v
      },
      expression: "toDate"
    }
  }) : _c('input-mask', {
    staticClass: "nepali-calendar",
    attrs: {
      "mask": "9999-99-99",
      "type": "text",
      "id": "toDate"
    },
    model: {
      value: (_vm.toDate),
      callback: function($$v) {
        _vm.toDate = $$v
      },
      expression: "toDate"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.organisationid != 7 && this.$store.getters.modules.includes('1.25')) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-12"
  }, [_c('process-info-box', {
    staticClass: "purchase",
    attrs: {
      "color-class": "bg-white",
      "icon-classes": ['fa', 'fa fa-inr'],
      "text": "Account Payable",
      "number": _vm.totalAccountPayable,
      "description": "",
      "selectedGradient": ['#8A64FB']
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-12"
  }, [_c('process-info-box', {
    staticClass: "cashIn",
    attrs: {
      "color-class": "bg-white",
      "icon-classes": ['fa', 'fa fa-inr'],
      "text": "Account Receivable",
      "number": _vm.totalAccountReceivable,
      "description": "",
      "selectedGradient": ['#70F7AD']
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-12"
  }, [_c('process-info-box', {
    attrs: {
      "color-class": "bg-white",
      "icon-classes": ['fa', 'fa fa-inr'],
      "text": "Cash Balance",
      "number": _vm.totalCashInHand,
      "description": "",
      "selectedGradient": ['#7CA1FD']
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-12"
  }, [_c('process-info-box', {
    attrs: {
      "color-class": "bg-white",
      "icon-classes": ['fa', 'fa fa-university'],
      "text": "Bank Balance",
      "number": _vm.totalBankBalance,
      "description": "",
      "selectedGradient": ['purple', 'violet']
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.$store.state.organisationid != 7 && this.$store.getters.modules.includes('1.25')) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  })]) : _vm._e(), _vm._v(" "), (this.$store.getters.modules.includes('1.25')) ? _c('div', {
    staticClass: "chartData"
  }, [_c('Chart', {
    attrs: {
      "type": "line"
    }
  })], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4 col-sm-6 col-xs-12"
  }, [_c('canvas', {
    attrs: {
      "id": "planet-chart"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4 col-sm-6 col-xs-12"
  }, [_c('canvas', {
    attrs: {
      "id": "planet-chart2"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4 col-sm-6 col-xs-12"
  }, [_c('canvas', {
    attrs: {
      "id": "planet-chart7"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4 col-sm-6 col-xs-12"
  }, [_c('canvas', {
    attrs: {
      "id": "planet-chart4"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4 col-sm-6 col-xs-12"
  }, [_c('canvas', {
    attrs: {
      "id": "planet-chart3"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4 col-sm-6 col-xs-12"
  }, [_c('canvas', {
    attrs: {
      "id": "planet-chart5"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-784af6b4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Dashboard.vue
// module id = 2332
// module chunks = 0